/**
 * AppShell Component
 * Main application layout with header, sidebar, and content area
 */

import { ReactNode } from 'react'
import { clsx } from 'clsx'

export interface AppShellProps {
  header?: ReactNode
  sidebar?: ReactNode
  children: ReactNode
  className?: string
}

export function AppShell({ header, sidebar, children, className }: AppShellProps) {
  return (
    <div className={clsx('h-screen flex flex-col overflow-hidden', className)}>
      {/* Header */}
      {header && <div className="flex-shrink-0">{header}</div>}

      {/* Main content area */}
      <div className="flex-1 flex overflow-hidden">
        {/* Sidebar */}
        {sidebar && <div className="flex-shrink-0">{sidebar}</div>}

        {/* Page content */}
        <main className="flex-1 overflow-auto bg-gray-50">
          <div className="h-full">{children}</div>
        </main>
      </div>
    </div>
  )
}
